import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, FollowUpActionCreators, IFollowUpDonorListResponse } from '@nkr/store/index';
import { ICenterBase, IFollowUpDonorForList } from '@nkr/models/index';
import { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import CenterSurveyList from './center-list';
import AdminSurveyList from './admin-list';
import Search from './search';
import { DonorAction } from '../donor-action';
import ConfirmRemove from './confirm-remove';

interface IProps {
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    itemId?: number,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonors: (centerId: number, firstName: string, lastName: string) => Promise<IFollowUpDonorListResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IFollowUpDonorForList[],
    firstName: string,
    lastName: string,
    confirmRemove: {
        show: boolean,
        data: IFollowUpDonorForList
    },
    isLoading: boolean
}

class FollowUpDonorList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        firstName: '',
        lastName: '',
        confirmRemove: {
            show: false,
            data: null
        },
        isLoading: true
    }

    gridApi: GridApi;
    columnApi: ColumnApi;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let { firstName, lastName } = this.state;

        this.props.showLoading('Getting list of donors, one moment please...').then(async () => {
            let response = await this.props.getDonors(this.props.centerId, firstName, lastName);

            if (response.data.success) {
                let list = response.data.results;
                let isLoading = list.length == 0 ? false : true;

                this.setState({
                    list,
                    isLoading,
                }, () => {
                    this.props.hideLoading();
                });
            }
        });
    }

    getCenterList = () => {
        let results: ICenterBase[] = [];

        for (let n = 0; n < this.state.list.length; n++) {
            let item = this.state.list[n];
            let exists = results.find(x => x.id == item.centerId);

            if (exists == null) {
                results.push({
                    id: item.centerId,
                    alias: item.centerAlias,
                    name: '',
                    isMemberCenter: true,
                    centerAddresses: []
                });
            }
        }

        return _.orderBy(results, (item) => {
            return item.alias
        }, 'asc');
    }

    handleSearchChange = (center: number, firstName: string, lastName: string) => {
        this.setState({
            firstName,
            lastName,
        });
    }

    handleSearch = () => {
        this.getData();
    }

    handleResetSearch = () => {
        this.setState({
            firstName: '',
            lastName: '',
        }, () => {
            this.getData();
        });
    }

    handleLoadingComplete = () => {
        this.setState({
            isLoading: false
        });
    }

    handleExport = () => {
        // let listType = micrositeListTypeMap.find(x => x.url == this.props.activeKey.toLowerCase());

        // let excludedColumns = ['isSelected', 'rowNumber'];
        // // let c = this.gridApi.getColumnDefs().filter(x=>x.hi).map(x => x['colId']).filter(colId => excludedColumns.indexOf(colId) < 0);

        // let c = this.columnApi.getAllDisplayedColumns().map(x => x.getColId()).filter(colId => excludedColumns.indexOf(colId) < 0);

        // let params: CsvExportParams = {
        //     columnGroups: true,
        //     fileName: `microsites-${listType.name.toLowerCase()}.csv`,
        //     columnKeys: c,
        //     processCellCallback: (params: ProcessCellForExportParams) => {
        //         // let colDef = params.column.getColDef();

        //         // if (colDef.colId == 'centerAlias') {
        //         //     if (params.node.data.centerAlias == '') {
        //         //         return 'Totals';
        //         //     }
        //         // }

        //         return params.value;
        //     }
        // };

        // this.gridApi.exportDataAsCsv(params);
    }

    handleItemSelected = (id: number, action: DonorAction) => {
        let data = this.state.list.find(x => x.id == id);

        if (action == DonorAction.Edit) {
            window.location.href = `/center/${data.centerId}/follow-up/donor/${id}`;
        }

        if (action == DonorAction.Remove) {
            this.setState({
                confirmRemove: {
                    show: true,
                    data
                }
            });
        }
    }

    handleConfirmRemove = () => {
        let id = this.state.confirmRemove.data.id;

        this.setState({
            confirmRemove: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                // this.props.markIncomplete(id).then(response => {
                //     this.props.hideLoading();

                //     if (response.data.success) {
                //         toast.success('Successfully updated survey');

                //         this.getData();
                //     }
                // });
            });
        });
    }

    handleCancelRemove = () => {
        this.setState({
            confirmRemove: {
                show: false,
                data: null
            }
        });
    }

    handleAdd = () => {
        window.location.href = `/center/${this.props.centerId}/follow-up/donor/add`;
    }

    render = () => {
        return (
            <div style={{ paddingTop: 20 }}>
                <Search
                    centerId={this.props.centerId}
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    isAdmin={this.props.isAdmin}
                    centerList={[]}
                    onChange={this.handleSearchChange}
                    onSearch={this.handleSearch}
                    onReset={this.handleResetSearch}
                    onAdd={this.handleAdd}
                />

                {!this.props.isAdmin && (
                    <div style={{ width: "100%", minHeight: "60vh", paddingTop: 0, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <CenterSurveyList
                            isAdminLogin={this.props.isAdminLogin}
                            centerId={this.props.centerId}
                            list={this.state.list}
                            isLoading={this.state.isLoading}
                            onLoadingComplete={this.handleLoadingComplete}
                            onGridReady={this.onGridReady}
                            onItemSelected={this.handleItemSelected}
                        />
                    </div>
                )}

                {this.props.isAdmin && (
                    <div style={{ width: "100%" }}>
                        <AdminSurveyList
                            centerId={this.props.centerId}
                            list={this.state.list}
                            isLoading={this.state.isLoading}
                            onLoadingComplete={this.handleLoadingComplete}
                            onGridReady={this.onGridReady}
                            onItemSelected={this.handleItemSelected}
                        />

                        <div>{this.state.list.length} microsites shown...</div>
                    </div>
                )}

                <ConfirmRemove
                    show={this.state.confirmRemove.show}
                    data={this.state.confirmRemove.data}
                    onConfirm={this.handleConfirmRemove}
                    onCancel={this.handleCancelRemove}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDonors: (centerId, firstName, lastName) => {
            return dispatch(FollowUpActionCreators.getDonors(centerId, firstName, lastName));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpDonorList);